module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Electric/Mixer-626883886a8317b09e0cbad49c42a505.svg";